export default "__VITE_ASSET__B6J75fvQ__"